/**
 * @module aem/components/product-offerings
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

export const PRODUCT_OFFERINGS_CONSTANTS = {
  HTTP_URL: 'http(s?)://',
  RED: 'Red',
  BACKORDER: 'BACKORDER',
  BACKORDERED: 'BACKORDERED',
  MEMORY: '128 GB',
  FRP: 'FRP',
  PRODUCTIMAGE: 'PRODUCTIMAGE',
  CONTENT: 'content',
  RED_128GB: 'Red128 GB',
  COMING_SOON: 'COMING SOON',
  NOT_AVAILABLE_FOR_SALE_ONLINE: 'NOT AVAILABLE FOR SALE ONLINE',
  PRE_ORDER: 'PRE ORDER',
  BACK_ORDER: 'BACK ORDER',
  OUT_OF_STOCK: 'OUT OF STOCK',
  IN_STOCK: 'IN STOCK',
  DEFAULT: 'DEFAULT',
  MAX_QTY: 10,
  MAX_EPIN_QTY: 15,
  ONE: 1,
  EIP: 'EIP',
  DEVICE_FIRST: 'DEVICE_FIRST',
  PAY_IN_FULL: 'Pay in full',
  IS_UPGRADE: 'isUpgrade',
  IS_EDIT: 'edit',
  DATE_FORMAT: 'MM/dd/yyyy',
  NAVIGATE_TO_PRODUCT_SELECTOR: '/product-selector/setup',
  COMPONENT_NAME: 'Product Selector',
  TILE_MANAGEMENT_SERVICE: 'TileManagementService',
  ACCESSORY: 'Accessory',
  ZIPCODE: 'zip',
  ACCESSORIES: 'accessories',
  DEVICE: 'device',
  HANDSET: 'handset',
  TABLET: 'tablet',
  VALIDATE_MSISDN: '/verify-phone-number',
  CART: '/cart',
  TWO: 2,
  UPGRADE_DEVICE: 'UPGRADE_DEVICE',
  BROWSE_DEVICES: '/browse-phones',
  SIM_CARD: 'simcard',
  DEVICE_PDP: '/product-details',
  ERROR_CODE: 'ORDER-1003',
  ID: 'id',
  CANCEL: 'cancel',
  HOME: '/home',
  ACCOUNT_LANDING: '/account-landing',
  MOBILE_INTERNET: 'mobileinternet',
};

export const BUTTON_CONSTANTS = {
  BACK_ID: 'backButton',
  SECONDARY_BUTTON: 'btn btn-secondary',
  PRIMARY_BUTTON: 'btn btn-primary',
};
